<!-- this only appears if the text prop is passed in from Search.vue -->
<template>
  <div class="SearchHeader" @click="broadcast('close-menus')">
    <h1 v-if="SearchHeaderText || text">{{ text || SearchHeaderText }}</h1>
  </div>
</template>

<script>
export default {
  name: 'SearchHeader',
  data () {
    return {
      //
    }
  },
  props: {
    text: String
  }
};
</script>

<style scoped lang="scss">
  .SearchHeader {
    max-width: 1125px;
    width: 80%;
    margin: 0 auto;
    @include smx { width: 100%; padding: 0 15px; }

    h1 {
      padding-top: 60px;
      padding-bottom: 40px;
      font-weight: normal;
      font-size: 48px;
      text-align: center;

      @include smx {
        font-size: 28px;
      }
    }
  }
</style>
